// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"213":"e3babc76","856":"82034dcb"}[chunkId] + ".js";
};